var PhotoView = {
	node :null,

	init: function() {
		PhotoView.node = $("<div id='inphotoview'><div class='photo'><img src='' class='img'><div class='loader'><img src='assets/loader.svg'></div><div class='info'></div><div class='clear'></div></div></div>");
		PhotoView.node.on("click", function() {
			//PhotoView.node.css("visibility", "hidden");
			PhotoView.node.removeClass("inph_reveal");
			$(".nav").show();

			if (PhotoView.idleReset != undefined) {
				clearInterval(PhotoView.idleReset);
				PhotoView.idleReset = undefined;
			}

			PhotoView.spot.preventShowingInfo = false;
		});
		//Quality.node.append(TPL.render("quality-main", {}));
//		$("#overlay").append(PhotoView.node);
		$("#panels").append(PhotoView.node);

		AppEvent.on(player, "HOTSPOT.STARTLOOKING", PhotoView.hotspot);

		AppEvent.on(player, "PLAYER.KEYUP", function(event) {
			if (PhotoView.node.hasClass("inph_reveal")) player.blockBackspace = true;
			
			if (event.key == 'Escape' || event.key == 'Backspace') {
				PhotoView.node.removeClass("inph_reveal");
				$(".nav").show();
			}
		});
	},

	hotspot: function(spot) {
		//alert("?");		
		if (spot.properties.place.place_type == "photo" && (spot.properties.place.preview_mode == "1" || spot.properties.place.preview_mode == "2")) {
			spot.noMore();
			spot.preventShowingInfo = true;

			PhotoView.spot = spot;
			
			//console.log(spot.properties.place.image_size)

			/*
			if (spot.properties.place.image_size.w > spot.properties.place.image_size.h) {
				PhotoView.node.find(".photo").addClass("hphoto");			
			} else {
				PhotoView.node.find(".photo").addClass("vphoto");			
			}
			*/
			var inf = PhotoView.node.find(".info");

			if (spot.properties.place.preview_mode == "2") {				
				inf.html("");
				inf.show();
				inf.append("<h4>" + spot.properties.place.place_name + "</h4>");
				inf.append("<div>" + spot.properties.place.description + "</div>");
			} else {
				inf.html("");
				inf.hide();
			}

			PhotoView.node.find(".photo").removeClass("hphoto");
			PhotoView.node.find(".photo").removeClass("vphoto");
			PhotoView.node.find(".loader").show();
			PhotoView.node.find(".photo .img").removeClass("loaded");

			var img = new Image();
			img.onload = function() {

				if (img.naturalWidth < img.naturalHeight) {
					PhotoView.node.find(".photo").removeClass("hphoto");
					PhotoView.node.find(".photo").addClass("vphoto");
				} else {
					PhotoView.node.find(".photo").removeClass("vphoto");
					PhotoView.node.find(".photo").addClass("hphoto");					
				}
				
				PhotoView.node.find(".photo .img").attr("src", "https://www.wkraj.pl/data/" + spot.properties.place.place_id + "_photo.jpg");
				PhotoView.node.find(".photo .img").addClass("loaded");
				PhotoView.node.find(".loader").hide();

				$(".nav").hide();
				PhotoView.node.addClass("inph_reveal");
			}
			img.src = "https://www.wkraj.pl/data/" + spot.properties.place.place_id + "_photo.jpg";

			PhotoView.idleReset = setInterval(function() {
				player.cancelIdle();
			}, 2000);

			/*			
			setTimeout(function() {
					spot.noMore();
				}, 350);
			*/
		}
	},
}

PluginManager.add(PhotoView);